import React, { Component } from 'react';
import TransparentButton from '../../../../../shared/button/transparent-button/TransparentButton';
import { EmptyList } from '../../../../../shared/empty-list/EmptyList';
import {
    extractPermissionsForUser,
    permissionsToHideArray
} from '../../../../../shared/models/permissions';
import { PermissionPipe } from '../../../../../shared/pipes/PermissionPipe';
import { Badge, BadgeClass } from '../../../../../shared/badge/Badge';
import { redirectToUserDetails } from '../../../../../routing/redirectService';
import { TableSearch } from '../../../../../shared/table-search/TableSearch';
import * as _ from 'lodash';
import './UserList.scss';
import { SpinLoader } from '../../../../../shared/spin-loader/SpinLoader';

const users_headers = [
    { key: 'NAME', value: 'NAME', showArrowSort: false },
    { key: 'SURNAME', value: 'SURNAME', showArrowSort: false },
    { key: 'EMAIL', value: 'EMAIL', showArrowSort: false },
    { key: 'STATUS', value: 'STATUS', showArrowSort: false },
    { key: 'TEAMS', value: 'TEAMS', showArrowSort: false },
    { key: 'PERMISSIONS', value: 'PERMISSIONS', showArrowSort: false },
    { key: null, value: '' } /* This is the actions column. */
];

export class UsersList extends Component {
    getUserPermissions = user =>
        extractPermissionsForUser(user).filter(
            permission => !_.includes(permissionsToHideArray, permission)
        );

    render() {
        const { users, loading } = this.props;

        return (
            <div className={'users-list'}>
                <div className="table">
                    <table>
                        <tbody>
                            <tr className={'table-options'}>
                                <td colSpan={users_headers.length - 4}>
                                    <TableSearch
                                        placeholder={'Search for users...'}
                                        onSearch={() => {
                                            /* todo: Add search users*/
                                        }}
                                    />
                                </td>
                            </tr>
                            <tr className="headers">
                                {users_headers.map(header => (
                                    <th key={header.key}>{header.key}</th>
                                ))}
                            </tr>

                            {loading ? (
                                <tr>
                                    <td colSpan={users_headers.length}>
                                        <SpinLoader />
                                    </td>
                                </tr>
                            ) : (
                                (users &&
                                    users.length &&
                                    users.map(user => (
                                        <tr key={user.id} className="data">
                                            <td>{user.firstName}</td>
                                            <td>{user.lastName}</td>
                                            <td>{user.email}</td>
                                            <td>
                                                {user.active ? (
                                                    <Badge
                                                        type={
                                                            BadgeClass.BlueOutline
                                                        }
                                                        text={'Active'}
                                                    />
                                                ) : (
                                                    <Badge
                                                        type={
                                                            BadgeClass.BlueOutline
                                                        }
                                                        className={'dismissed'}
                                                        text={'Inactive'}
                                                    />
                                                )}
                                            </td>
                                            <td>
                                                {user.belongsInTeams.map(
                                                    team => (
                                                        <div key={team.id}>
                                                            {team.name}
                                                        </div>
                                                    )
                                                )}
                                            </td>
                                            <td style={{ padding: '12.5px 0' }}>
                                                {this.getUserPermissions(
                                                    user
                                                ).map(permission => (
                                                    <div key={permission}>
                                                        {PermissionPipe(
                                                            permission
                                                        )}
                                                    </div>
                                                ))}
                                            </td>
                                            <td>
                                                <TransparentButton
                                                    onClick={() =>
                                                        redirectToUserDetails(
                                                            user.id,
                                                            `${user.firstName} ${user.lastName}`
                                                        )
                                                    }
                                                >
                                                    Details
                                                </TransparentButton>
                                            </td>
                                        </tr>
                                    ))) || (
                                    <tr
                                        className="data"
                                        style={{ textAlign: 'center' }}
                                    >
                                        <td colSpan={users_headers.length}>
                                            <EmptyList />
                                        </td>
                                    </tr>
                                )
                            )}
                        </tbody>
                    </table>
                </div>
            </div>
        );
    }
}
